import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id 75EE1BFB-90E7-4500-A7E1-72E898059E16
 * name manjaro
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/manjaro.svg
 * tags
 * - Brand / Logo 
 */
export const ManjaroIcon = createSvgIcon(<><path d="M2 2V22H7.6V7.6H14.8V2H2M9.2 9.2V22H14.8V9.2H9.2M16.4 2V22H22V2H16.4Z" /></>, 'ManjaroIcon');
export default ManjaroIcon